import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { INDUSTRY_ROWS } from "@/content/site";
import { useMedia } from "@/context/MediaContext";
import { MediaFrame } from "@/components/media/MediaFrame";
import { Eyebrow, Reveal } from "@/components/site/Reveal";

const IndustriesEditorial = () => {
  const [hover, setHover] = useState(0);
  const { items } = useMedia("industries", 0);
  return (
    <section id="industries" className="py-32 md:py-48 border-t border-[#2E1B16]/10" data-testid="industries" aria-labelledby="industries-heading">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8">
          <div className="lg:col-span-4">
            <Reveal><Eyebrow>Industries</Eyebrow></Reveal>
            <Reveal delay={0.05}>
              <h2 id="industries-heading" className="mt-7 font-display uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95] text-[#2E1B16]">
                We do our best work where there's something <span className="font-accent font-normal normal-case text-[#38BDF8] text-[1.1em]">real to show.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 text-lg text-[#2E1B16]/60 leading-relaxed max-w-sm">
                Food is where we started and where we're strongest. The same thinking works for any business with a real product, process or operation behind it.
              </p>
            </Reveal>
            <div className="hidden lg:block mt-14 w-[70%]">
              {items[0] && <MediaFrame item={items[0]} ratio="aspect-[4/5]" autoplay hoverPlay={false} className="rounded-sm" />}
            </div>
          </div>

          <ol className="lg:col-span-7 lg:col-start-6 border-t border-[#2E1B16]/12" data-testid="industry-rows">
            {INDUSTRY_ROWS.map((r, i) => (
              <li key={r.title} className="border-b border-[#2E1B16]/12">
                <Link to={r.to} onMouseEnter={() => setHover(i)} onFocus={() => setHover(i)} data-testid={`industry-row-${i}`}
                  className="group grid grid-cols-[2.5rem_1fr_auto] items-baseline gap-4 py-5 md:py-6">
                  <span className="text-xs font-semibold text-[#2E1B16]/35 tabular-nums">{String(i + 1).padStart(2, "0")}</span>
                  <span>
                    <span className={`font-display uppercase text-2xl sm:text-3xl lg:text-4xl tracking-tight transition-colors duration-300 ${hover === i ? "text-[#2E1B16]" : "text-[#2E1B16] lg:text-[#2E1B16]/55 group-hover:text-[#2E1B16]"}`}>
                      {r.title}
                    </span>
                    {r.food && <span className="ml-3 align-middle text-[0.6rem] label-eyebrow text-[#38BDF8]">food</span>}
                    <span className={`block mt-1 text-[#2E1B16]/55 text-base transition-all duration-500 ${hover === i ? "opacity-100 translate-y-0" : "opacity-100 translate-y-0 lg:opacity-0 lg:-translate-y-1"}`}>{r.line}</span>
                  </span>
                  <ArrowUpRight size={22} className={`transition-all duration-300 ${hover === i ? "text-[#38BDF8]" : "text-[#2E1B16]/40 lg:text-[#2E1B16]/25 -rotate-45 group-hover:rotate-0"}`} />
                </Link>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default IndustriesEditorial;
